/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.report').controller('CreateReportModalController',
    function (_, $uibModalInstance, ReportViewService, UtilsService, amDateFormatFilter, report, showPartners) {
        var self = this;

        var defaultReportName = function () {
            var dateString = amDateFormatFilter(new Date(), 'MM-DD-YYYY hhmmA');
            var reportName = '';
            switch (self.selectedReport.generatorName) {
                case ReportViewService.PARTNER_DELIVERY_REPORT_CLASS:
                    reportName = self.reportMode + ' Delivery Report';
                    break;
                case ReportViewService.PARTNER_PLANNER_DELIVERY_REPORT_CLASS:
                    reportName = 'Partner Planner Delivery Report';
                    break;
                case ReportViewService.SLA_DELIVERY_REPORT_CLASS:
                    reportName = 'SLA Delivery Metrics';
                    break;
                case ReportViewService.DISTRIBUTION_REPORT_CLASS:
                    reportName = self.reportMode + ' Distribution Report';
                    break;
                case ReportViewService.PARTNER_PROFILES_REPORT_CLASS:
                    reportName = 'Partner Profiles Report';
                    break;
                case ReportViewService.HIERARCHICAL_NETWORK_REPORT_CLASS:
                    reportName = 'Networks Hierarchical Metadata Report';
                    break;
                case ReportViewService.HIERARCHICAL_SHOW_REPORT_CLASS:
                    reportName = 'Series Movie Hierarchical Metadata Report';
                    break;
                case ReportViewService.HIERARCHICAL_SEASON_VOLUME_REPORT_CLASS:
                    reportName = 'Season Volume Hierarchical Metadata Report';
                    break;
                case ReportViewService.COLLABORATOR_REPORT_CLASS:
                    reportName = 'Collaborators Report';
                    break;
                case ReportViewService.PACKAGE_BATCH_MODIFY_REPORT_CLASS:
                    reportName = 'Package Batch Modify Metadata Report';
                    break;
                case ReportViewService.PACKAGE_REPORT_CLASS:
                    reportName = 'Package Report';
                    break;
                case ReportViewService.PACKAGE_ALL_METADATA_REPORT_CLASS:
                    reportName = 'Package Metadata Report';
                    break;
                case ReportViewService.PACKAGE_MEDIA_REPORT_CLASS:
                    reportName = 'Media Report';
                    break;
                case ReportViewService.AUDIT_LEVEL_REPORT_CLASS:
                    reportName = 'Partner Delivery Report with Distribution Metadata';
            }
            return reportName + ' ' + dateString;
        };

        self.selectedReport = report;
        self.showPartners = showPartners;

        self.reportMode = 'Basic';
        self.includeMasterPkgs = true;
        self.reportName = defaultReportName();

        self.handleModeChange = function () {
            self.reportName = defaultReportName();
        };

        self.showMode = function () {
            return self.selectedReport.generatorName === ReportViewService.PARTNER_DELIVERY_REPORT_CLASS ||
                self.selectedReport.generatorName === ReportViewService.DISTRIBUTION_REPORT_CLASS;
        };

        self.showInclude = function () {
            return self.selectedReport.generatorName === ReportViewService.PARTNER_DELIVERY_REPORT_CLASS ||
                self.selectedReport.generatorName === ReportViewService.SLA_DELIVERY_REPORT_CLASS ||
                self.selectedReport.generatorName === ReportViewService.COLLABORATOR_REPORT_CLASS ||
                self.selectedReport.generatorName === ReportViewService.PACKAGE_REPORT_CLASS ||
                self.selectedReport.generatorName === ReportViewService.PACKAGE_ALL_METADATA_REPORT_CLASS ||
                self.selectedReport.generatorName === ReportViewService.CLIP_PACKAGE_ALL_METADATA_REPORT ||
                self.selectedReport.generatorName === ReportViewService.PACKAGE_MEDIA_REPORT_CLASS ||
                self.selectedReport.generatorName === ReportViewService.AUDIT_LEVEL_REPORT_CLASS;
        };

        self.showIncludeArchived = function () {
            return self.selectedReport.generatorName === ReportViewService.COLLABORATOR_REPORT_CLASS;
        };

        self.updatePartnerList = () => {
            ReportViewService.queryForPartners(self.includeHiddenPartners).then(function (partners) {
                self.partners = partners;
            });
        };

        self.updatePartnerList();

        const isReportNameValid = () => {
            return UtilsService.isFileNameValid(self.reportName);
        };

        self.isReportNameValid = _.memoize(isReportNameValid, () => self.reportName);

        self.reportNameChanged = () => {
            self.isReportNameValid.cache.clear();
        };

        self.onOk = function () {
            var reportOptions = {
                name: self.reportName,
                mode: (self.showMode())? self.reportMode : null,
                includeMasterPkgs: (self.selectedReport.showIncludePackagesOptions)? self.includeMasterPkgs : null,
                includeClipToolPkgs: (self.selectedReport.showIncludePackagesOptions)? self.includeClipToolPkgs : null,
                includeArchiveContent: (self.showIncludeArchived())? self.includeArchived : null
            };

            if (self.showPartners) {
                reportOptions.selectedPartners = (_.isArray(self.selectedPartners)) ?
                    self.selectedPartners : _.concat(self.selectedPartners);
            }

            $uibModalInstance.close(reportOptions);
        };

        self.cancel = function () {
            $uibModalInstance.dismiss();
        };

    });
